var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSelected = function SvgSelected(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 146 134"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m74.257 123.534-32.25-26.242-8.749 10.752 43.002 34.991 74.978-92.142-10.752-8.75-66.229 81.391Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M76.679 79.882 51.282 59.216l-6.89 8.467 33.864 27.555 59.044-72.56-8.467-6.89-52.154 64.094Z"
  })));
};
export default SvgSelected;